import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteAdminConversationCategory } from '@entities/AdminConversationCategory/api/handlers/deleteAdminConversationCategoryt';

export function useDeleteAdminConversationCategory() {
    const qc = useQueryClient();

    return useMutation({
        mutationFn: deleteAdminConversationCategory,
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['adminConversationCategories'] });
        },
    });
}
